import { Component, ViewChild, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { Dropdown } from 'flowbite';
import { Observable, map } from 'rxjs';
import { deepCopy } from 'src/services/util';

@Component({
  selector: 'formly-multi-select',
  template: `
    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" *ngIf="to.label">{{ to.label }}</label>
    <button
      #btn
      id="dropdownSearchButton"
      data-dropdown-toggle="dropdownSearch"
      data-dropdown-placement="bottom"
      class="text-center inline-flex items-center w-full bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
      type="button">
      {{ 'Select Indicators' | translate }}
      <svg
        class="w-4 h-4 ml-2"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        ></path>
      </svg>
    </button>

    <div #dropdown id="dropdownSearch" class="z-10 hidden bg-white rounded-lg shadow w-60 dark:bg-gray-700">
      <div class="p-3">
        <label for="input-group-search" class="sr-only">Search</label>
        <div class="relative">
        <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path></svg>
        </div>
          <input
            (keyup)="search($event)"
            type="text"
            id="input-group-search"
            class="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Search indicator"
          />
        </div>
      </div>
      <ul
        class="h-48 px-3 pb-3 overflow-y-auto text-sm text-gray-700 dark:text-gray-200"
        aria-labelledby="dropdownSearchButton"
      >
        <li *ngFor="let option of to.options | formlySelectOptions: field | async">
          <div
            class="flex items-center p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-600"
          >
            <input
              (change)="changeSelection()"
              id="checkbox-item-{{ option.value }}"
              type="checkbox"
              [value]="option.value"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
            />
            <label
              for="checkbox-item-{{ option.value }}"
              class="w-full ml-2 text-sm font-medium text-gray-900 rounded dark:text-gray-300"
              >{{ option.label }}</label
            >
          </div>
        </li>
      </ul>
    </div>
  `,
})
export class MultiSelectFieldType extends FieldType<FieldTypeConfig> implements OnInit, AfterViewInit {
  @ViewChild('btn') btn!: ElementRef;
  @ViewChild('dropdown') dropdown!: ElementRef;
  items: any[] | Observable<any[]> | undefined = [];
  dropdwn!: Dropdown;

  constructor() {
    super();
  }

  ngOnInit() {
    this.items = deepCopy(this.to.options);
  }

  ngAfterViewInit() {
    this.dropdwn = new Dropdown(this.dropdown.nativeElement, this.btn.nativeElement);
  }

  search(event: any) {
    let searchValue = event.target.value.toLowerCase();

    if (Array.isArray(this.items)) {
      this.to.options = this.items.filter((option: any) => {
        return option.label.toLowerCase().includes(searchValue);
      });
    } else {
      this.items?.pipe(
        map((options: any[]) =>
          options.filter((option: any) =>
            option.name.toLowerCase().includes(searchValue)
          )
        )
      ).subscribe((filteredOptions: any[]) => {
        this.to.options = filteredOptions;
      });
    }
  }

  changeSelection() {
    //get selected values
    let selectedValues = Array.from(this.dropdown.nativeElement.querySelectorAll('input[type="checkbox"]:checked')).map((el: any) => el.value);
    this.formControl.setValue(selectedValues);
  }

}
